import React, {useContext} from 'react'
import { Selected } from '../../../../context/context'
import {
    Content,
    Title,
    RadioInner,
    RadioLabel,
    RadioButton,
    Note,
} from './Elements'
import {
    titleMotion,
    radioInnerMotion,
    radioMotion,
    noteMotion,
} from './Motion'


const Colors = ({ colors, setSteps }) => {

    const [selected, setSelected] = useContext(Selected)

    const handleClick = (e) => {
        setSelected({...selected, color: e.target.value})
        setSteps(1)
    }

    return(
        <Content>
            <Title
            variants={titleMotion}
            initial='initial'
            animate='animate'
            exit='exit'
            >
                Elegí el color de la prenda*
            </Title>
            <RadioInner
            variants={radioInnerMotion}
            initial='initial'
            animate='animate'
            exit='exit'
            >
                {
                    colors.length !== 0 &&
                    colors.map(item => {

                        let color

                        switch(item){
                            case 'azul-marino':
                                color = "#003366"
                                break
                            case 'azul-francia':
                                color = "#281ece"
                                break
                            case 'verde-benetton':
                                color = "#0c8711"
                                break
                            case 'rojo':
                                color = "#ae350b"
                                break
                            case 'negro':
                                color = "#000000"
                                break
                            case 'gris':
                                color = "#9b9b9b"
                                break
                            default:
                                color = "#ffffff"    
                        }

                        return(
                            <RadioLabel 
                            variants={radioMotion}
                            key={item} 
                            >
                                <input 
                                    key={item}
                                    name="color" 
                                    type="radio" 
                                    value={item} 
                                    onClick={handleClick}
                                />  
                                <RadioButton color={color}/>
                            </RadioLabel>
                        )
                    })
                }
            </RadioInner>
            <Note
            variants={noteMotion}
            initial='initial'
            animate='animate'
            exit='exit'
            >*Consultá por otro color que necesites</Note>
        </Content>    
    )
}

export default Colors